import React, { useMemo } from "react";
import { Button, Modal } from "antd";

import TextInfo from "../../../../../components/common/TextInfo/TextInfo";

import "../../../../../components/common/styles.css";
import { CanAccess } from "../../../../../components/template/authorization/Authorization";

const ChangeStatusDialog = ({
  visible,
  handleCancel,
  handleSave,
  onInputChange,
  errors,
  data,
  onImageChange,
  handleUploadImage,
  documentImg,
  handleSavePermissions = true,
}) => {
  const isShowDocumentField = useMemo(() => {
    if (data.status === "Mitra") return true;
    return false;
  }, [data]);

  const handleChange =
    (type, field = "") =>
    (event) => {
      if (type === "number") {
        onInputChange(field, event.value, "changeStatus");
      } else if (type === "input") {
        const { name, value } = event.target;
        onInputChange(name, value, "changeStatus");
      }
    };

  return (
    <Modal
      className="modal-form"
      title="Ubah Status"
      visible={visible}
      onCancel={handleCancel}
      width={600}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <CanAccess
          role={handleSavePermissions}
          yes={
            <Button
              key="submit"
              type="primary"
              onClick={handleSave}
              className="btn-modal"
            >
              Simpan
            </Button>
          }
        />,
      ]}
    >
      <div className="modal-form-content">
        <TextInfo
          title="Pilih Status"
          type={"radio"}
          id={"status"}
          handleChange={handleChange("input")}
          error={errors?.status}
          value={data.status}
          radioData={[
            {
              label: "Terjual di e-Boutique",
              value: "E-Boutique",
            },
            {
              label: "Terjual ke Mitra",
              value: "Mitra",
            },
          ]}
          isForm
        />
        <TextInfo
          title="Harga Terjual"
          value={data.sellPrice}
          type={"input"}
          id={"sellPrice"}
          handleChange={handleChange("number", "sellPrice")}
          error={errors?.sellPrice}
          placeholder={"Masukkan harga terjual"}
          isInputNumber
          isForm
        />
        <TextInfo
          title="Biaya Lain-lain"
          value={data.otherFee}
          type={"input"}
          id={"otherFee"}
          handleChange={handleChange("number", "otherFee")}
          error={errors?.otherFee}
          placeholder={"Masukkan biaya lain-lain"}
          isInputNumber
          isForm
        />
        <TextInfo
          title="Keterangan"
          value={data.description}
          type={"input"}
          id={"description"}
          handleChange={handleChange("input")}
          error={errors?.description}
          placeholder={"Masukkan keterangan"}
          isForm
          isTextArea
        />
        <TextInfo
          title="Link Penawaran"
          value={data.offeringLink}
          type={"input"}
          id={"offeringLink"}
          handleChange={handleChange("input")}
          error={errors?.offeringLink}
          placeholder={"Masukkan Link Penawaran"}
          isForm
        />

        {isShowDocumentField && (
          <TextInfo
            title="Surat Jalan"
            type={"upload"}
            id={"document"}
            helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
            handleImageChange={onImageChange("document")}
            customRequest={handleUploadImage("document")}
            fileList={documentImg}
            error={errors?.document}
            isForm
          />
        )}
      </div>
    </Modal>
  );
};

export default ChangeStatusDialog;
